import { render, staticRenderFns } from "./TdotCompetition.vue?vue&type=template&id=7c2d9b18&scoped=true"
import script from "./TdotCompetition.vue?vue&type=script&lang=js"
export * from "./TdotCompetition.vue?vue&type=script&lang=js"
import style0 from "./TdotCompetition.vue?vue&type=style&index=0&id=7c2d9b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2d9b18",
  null
  
)

export default component.exports